<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M4 17.3333C8.8 6.66659 23.2 6.66659 28 17.3333"
        :stroke="stroke"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 22.6667C13.7908 22.6667 12 20.8759 12 18.6667C12 16.4575 13.7908 14.6667 16 14.6667C18.2092 14.6667 20 16.4575 20 18.6667C20 20.8759 18.2092 22.6667 16 22.6667Z"
        :stroke="stroke"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
<script>
import {DEFAULT_BRAND_SECONDARY_COLOR} from '../constants';

export default {
  inject: ['getBrandSecondaryBackground'],
  computed: {
    stroke() {
      const stroke = this.getBrandSecondaryBackground();
      console.log('brand primary background: ', stroke);
      return stroke || DEFAULT_BRAND_SECONDARY_COLOR;
    },
  },
};
</script>
